import { useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { basescanUrl, shortAddress, type EssenceContract } from '../lib/contracts';

export function CopyAddress({ contract }: { contract: EssenceContract }) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(contract.address);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1600);
    } catch {
      setCopied(false);
    }
  }

  return (
    <div className="rounded-xl border border-essence-line bg-essence-panel p-4 shadow-sm shadow-essence-ink/5 sm:p-5">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <p className="font-display text-base font-semibold text-essence-ink">{contract.name}</p>
          {contract.note ? <p className="mt-1 text-sm text-essence-mute">{contract.note}</p> : null}
        </div>
        <a
          href={basescanUrl(contract)}
          target="_blank"
          rel="noreferrer"
          className="text-sm text-essence-teal underline-offset-2 hover:underline"
        >
          Basescan
        </a>
      </div>
      <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:items-center">
        <code className="min-w-0 flex-1 break-all rounded-lg bg-essence-paper px-3 py-2 font-mono text-xs text-essence-ink sm:text-sm">
          <span className="sm:hidden">{shortAddress(contract.address)}</span>
          <span className="hidden sm:inline">{contract.address}</span>
        </code>
        <button
          type="button"
          onClick={handleCopy}
          className="inline-flex shrink-0 items-center justify-center gap-2 rounded-lg border border-essence-line bg-essence-surface px-3 py-2 text-sm font-medium text-essence-ink transition hover:border-essence-teal/50"
          aria-label={`Copy ${contract.name} address`}
        >
          {copied ? <Check className="h-4 w-4 text-essence-teal" /> : <Copy className="h-4 w-4" />}
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
    </div>
  );
}
